document.addEventListener("DOMContentLoaded", function() {

  
    // EVENT SINGLE
    // Expand/ close Description Read More

    function toggleEventDescription(){

        var buttons = document.querySelectorAll(".troxy-event__description-wrap .read-more-button");
    
        buttons.forEach(function(button) {
    
            var isExpanded = false;
    
        button.addEventListener("click", function() {
            var totalHeight = 0;
    
            var el = this;
            var p = el.parentElement;
            var up = p.parentElement;
            var ps = up.querySelectorAll("p");
    
    
            // Measure how tall inside should be by adding together heights of all inside paragraphs (except read-more paragraph)
            ps.forEach(function(para) {
            totalHeight += para.offsetHeight;
            });
    
            var total_calc = totalHeight - button.offsetHeight;
    
          // Use setTimeout to simulate a frame and initiate the animation
          setTimeout(function () {
    
            if(total_calc == up.offsetHeight) {
                up.style.height = 220 + "px";
                button.innerText = 'Read more';
                p.classList.remove("expanded");
                up.style.maxHeight = "220px";
                isExpanded = false;
                
            } else {
                button.innerText = 'Read less';
                up.style.height = total_calc + "px";
                p.classList.add("expanded");
                up.style.maxHeight = "9999px";
                isExpanded = true;
            }
    
            button.setAttribute("aria-expanded", isExpanded ? "true" : "false");
            
          }, 0);
    
    
            // Prevent jump-down
            return false;
        });
        });
    }
      
      if(document.querySelector("#event-description")) {
        toggleEventDescription();
      }
      // END Event Single
  
});